module.exports = __webpack_public_path__ + "media/images/application/template/logo-hire-2a3fb40b075b7f02671fc844982788e9.svg";